// Hosanna counts awareness entries with role 'screen' as screens, not people
// (frontend presence-roster). The role is remembered so providers created while
// it is set (e.g. after a session switch) get it too. No service import: this
// module is used by HosannaConnection, so it must stay cycle-free.
let currentRole = null;

export function applyHosannaPresenceRole(provider) {
  if (currentRole) provider?.awareness?.setLocalStateField('role', currentRole);
}

export function setHosannaPresenceRole(service, role) {
  currentRole = role;
  const workspaces = service?.hosannaWorkspaces;
  if (!workspaces) return;
  for (const wsId of workspaces.keys()) {
    service.providers?.get(wsId)?.awareness?.setLocalStateField('role', role);
  }
}
